/* ==========================================================================
   BMO ETF Dashboard
   ========================================================================== */
import "./base";
import "./components";
import "./utilities";

/* ==========================================================================
   Alpine
   n.b. Must load afer components.
   ========================================================================== */
import Alpine from "alpinejs";
import infiniteBlogScroll from "./components/blog";
declare global {
  interface Window {
    Alpine: any;
  }
}

Alpine.data("infiniteBlogScroll", infiniteBlogScroll as any);
window.Alpine = Alpine;

Alpine.start();
